/**
 * Record audio from the microphone, render a waveform and download the audio.
 *
 * Copy from wavesurfer.js but modify startRecording method
 */
import RecordPlugin from 'wavesurfer.js/dist/plugins/record'

class WsRecordPlugin extends RecordPlugin {
  /** Request access to the microphone and start monitoring incoming audio */
  public override async startMic(options?: MediaTrackConstraints): Promise<MediaStream> {
    let stream: MediaStream
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        audio: options ?? true,
      })
    } catch (err) {
      throw new Error('Error accessing the microphone: ' + (err as Error).message)
    }
    const { onDestroy, onEnd } = this.renderMicStream(stream)
    this.subscriptions.push(this.once('destroy', onDestroy))
    this.subscriptions.push(this.once('record-end', onEnd))
    // @ts-ignore
    this.stream = stream

    return stream
  }

  static visualizeStream(plugin: WsRecordPlugin, stream: MediaStream) {
    const { onDestroy, onEnd } = plugin.renderMicStream(stream)
    plugin.subscriptions.push(plugin.once('destroy', onDestroy))
    plugin.subscriptions.push(plugin.once('record-end', onEnd))
    // @ts-ignore
    plugin.stream = stream
  }
}

export default WsRecordPlugin
